import React from 'react'

const SvgSurfFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M20.599 2.34c-2.523-1.383-7.934.495-12.6 5.16C4.172 11.33 1.982 16.205 2 19c.004.495.731.302 1.484.102.16-.042.32-.085.475-.121l3.13-3.13-2.193-2.094 1.035-1.085c.242-.254.519-.48.82-.663.3-.183.634-.33.99-.415.355-.085.75-.112 1.154-.034.41.08.813.268 1.146.586l.385.368L20.6 2.34zM21.66 3.4L5.075 19.986c-.04.18-.093.37-.144.559-.203.743-.398 1.457.105 1.456 2.796-.002 7.652-2.188 11.464-6 4.665-4.665 6.543-10.077 5.16-12.6z' />
    <path d='M8.33 13.016a1.42 1.42 0 00-.241.037 1.966 1.966 0 00-.559.237c-.184.112-.36.254-.515.417l.803.767 1.187-1.243a.784.784 0 00-.398-.198 1.018 1.018 0 00-.277-.017z' />
  </svg>
)

export default SvgSurfFilled
